import React, { FC, useEffect } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { DataLoader } from './ConfirmDataLoader'
import { ContractModificationErrorHandler } from '../ContractModificationErrorHandler'
import { ContractModificationRequestPreview } from './ContractModificationRequestPreview'
import { ConfirmContractModificationForm } from './ModificationConfirmForm'
import { ConfirmSuccess } from './Success'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const ConfirmContractModification: FC = () => {
  const { t } = useTranslation(['common', 'contractModification', 'titles'])
  const [view, setView] = React.useState<'default' | 'success'>('default')
  const [params] = useSearchParams()
  const { frontPagePath, confirmContractModificationPath } = useContractPaths()

  useEffect(() => {
    if (params.get('success')) {
      setView('success')
    }
  }, [params, setView])

  return (
    <TitleController title={t('titles:contractModification')}>
      <ResidentAppView
        title={t('contractModification:view.title')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ContractModificationErrorHandler
            view="confirm"
            restartPath={confirmContractModificationPath}
          >
            <DataLoader>
              {(data) => (
                <>
                  {view === 'success' && <ConfirmSuccess />}

                  {view === 'default' && (
                    <ConfirmContractModificationForm
                      contractModificationRequestId={
                        data.contractModificationRequest.id
                      }
                      userMetadata={data.userMetadata}
                    >
                      <ContractModificationRequestPreview
                        contractModificationRequest={
                          data.contractModificationRequest
                        }
                        tenants={data.tenants}
                      />
                    </ConfirmContractModificationForm>
                  )}
                </>
              )}
            </DataLoader>
          </ContractModificationErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
